import { useCallback } from "react";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import FileRow from "./FileRow"; // the memoized component above

export default function FileUploads({
    fields,
    filesData,
    setFilesData,
    errors
}) {

    //   useEffect(()=>{
    //     console.log("File Rows Updated: ", fileRows);
    //   }, [fileRows]);

    // Handles changes in a specific row 
    const handleRowChange = useCallback((index, updatedValues) => {
        setFilesData((prev) => {
            const copy = [...prev];
            copy[index] = updatedValues;
            return copy;
        });
    }, []);

    // Handles adding a new row
    const handleAddRow = () => {
        setFilesData((prev) => [...prev, {}]);
    };

    // Handles removing a specific row
    const handleRemoveRow = (index) => {
        if (filesData.length === 0) return; // Prevent removing the last row
        const newFileRows = filesData.filter((_, i) => i !== index);
        setFilesData(newFileRows);
    };

    return (
        <MDBox>
            {filesData.map((values, i) => (
                // Render a FileRow for each entry in filesData
                <FileRow
                    key={i}
                    rowIndex={i}
                    fields={fields}
                    values={values}
                    onChange={handleRowChange}
                    onRemove={handleRemoveRow}
                    error={errors[i] || {}}
                />
            ))}

            <MDBox
                sx={{
                    border: "1px solid #e0e0e0",
                    borderRadius: "8px",
                    padding: "16px",
                }}
                display="flex"
            >
                {/* Button to add a row */}
                <MDButton
                    fullWidth
                    variant="gradient"
                    color="dark"
                    height="45px"
                    onClick={handleAddRow}
                >
                    Add A Certificate
                </MDButton>
            </MDBox>
        </MDBox>
    );
}
